import { render, staticRenderFns } from "./AchievementModal.vue?vue&type=template&id=49fdeb06&lang=pug&"
import script from "./AchievementModal.vue?vue&type=script&lang=js&"
export * from "./AchievementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports